import React from 'react';
import '../styles/index.less.js';
import { useMergedState } from 'rc-util';
import { isFunction } from 'lodash';
import LeftSVG from '../LeftSVG/index.js';
import RightSVG from '../RightSVG/index.js';
import classNames from 'classnames';

var TiTrapezoid = function TiTrapezoid(props) {
  var _a;
  var value = props.value,
    onChange = props.onChange,
    defaultValue = props.defaultValue,
    _b = props.options,
    options = _b === void 0 ? [] : _b,
    disabled = props.disabled;
  var _c = useMergedState(defaultValue, {
      value: value,
      onChange: onChange
    });
    _c[0];
    var setActiveValue = _c[1];
  if ((options === null || options === void 0 ? void 0 : options.length) !== 2) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var leftProps = options[0];
  var rightProps = options[1];
  var handleChange = function handleChange(changed) {
    if (disabled) {
      return;
    }
    setActiveValue(changed);
    if (isFunction(onChange)) {
      onChange(changed);
    }
  };
  var onLeftClick = function onLeftClick() {
    handleChange(leftProps.value);
  };
  var onRightClick = function onRightClick() {
    handleChange(rightProps.value);
  };
  var trapezoidCls = classNames('ti-trapezoid', (_a = {}, _a['ti-trapezoid-left-active'] = leftProps.value === value, _a['ti-trapezoid-right-active'] = rightProps.value === value, _a['ti-trapezoid-disabled'] = disabled, _a));
  return /*#__PURE__*/React.createElement("div", {
    className: trapezoidCls
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-left",
    onClick: onLeftClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-left-icon"
  }, /*#__PURE__*/React.createElement(LeftSVG, null)), /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-left-label"
  }, leftProps.label)), /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-right",
    onClick: onRightClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-right-icon"
  }, /*#__PURE__*/React.createElement(RightSVG, null)), /*#__PURE__*/React.createElement("div", {
    className: "ti-trapezoid-right-label"
  }, rightProps.label)));
};

export { TiTrapezoid as default };
